/**
 * @generated SignedSource<<69c75ee3cc09d21b299ebfa61cb78b1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Locale = "EN" | "LT";
export type SortDirection = "ASC" | "DESC";
export type UpdateHotelInput = {
  aboutLocationText?: TextBlockInput | null;
  city?: SetEntityInput | null;
  descriptionText?: TextBlockInput | null;
  features?: ReadonlyArray<string> | null;
  location?: LocationInput | null;
  name?: string | null;
  reviews?: ReadonlyArray<string> | null;
  stars?: number | null;
};
export type LocationInput = {
  lat?: number | null;
  lng?: number | null;
};
export type SetEntityInput = {
  id: string;
};
export type TextBlockInput = {
  blocks: ReadonlyArray<BlockInput>;
};
export type BlockInput = {
  data: string;
  locale: Locale;
};
export type RoomSorting = {
  capacity?: SortDirection | null;
  name?: SortDirection | null;
};
export type HotelEditMainMutation$variables = {
  after?: string | null;
  first: number;
  id: string;
  input: UpdateHotelInput;
  search?: string | null;
  sort?: RoomSorting | null;
};
export type HotelEditMainMutation$data = {
  readonly updateHotel: {
    readonly " $fragmentSpreads": FragmentRefs<"HotelEditTabs_hotel" | "HotelSidebar_hotel">;
  };
};
export type HotelEditMainMutation = {
  response: HotelEditMainMutation$data;
  variables: HotelEditMainMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TextBlockConnection",
    "kind": "LinkedField",
    "name": "blocks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TextBlockEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TextBlock",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locale",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "data",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v9/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HotelEditMainMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Hotel",
        "kind": "LinkedField",
        "name": "updateHotel",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HotelEditTabs_hotel"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HotelSidebar_hotel"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "HotelEditMainMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Hotel",
        "kind": "LinkedField",
        "name": "updateHotel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "MediaConnection",
            "kind": "LinkedField",
            "name": "media",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": "media(first:2147483647)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "search",
                "variableName": "search"
              },
              {
                "kind": "Variable",
                "name": "sort",
                "variableName": "sort"
              }
            ],
            "concreteType": "RoomConnection",
            "kind": "LinkedField",
            "name": "rooms",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoomEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Room",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nameString",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "capacity",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stars",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "features",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reviews",
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aboutLocation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userEdited",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "City",
            "kind": "LinkedField",
            "name": "city",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lng",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Text",
            "kind": "LinkedField",
            "name": "descriptionText",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Text",
            "kind": "LinkedField",
            "name": "aboutLocationText",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalId",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "MediaConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Media",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "S120X120"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "externalUrl",
                            "storageKey": "externalUrl(size:\"S120X120\")"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w262"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "src",
                            "storageKey": "src(size:\"w262\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "MediaEditor_mediable_media",
                "kind": "LinkedHandle",
                "name": "media"
              }
            ],
            "type": "Mediable",
            "abstractKey": "__isMediable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LogEntry",
                "kind": "LinkedField",
                "name": "logs",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v11/*: any*/),
                  (v14/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "context",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "severity",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Logable",
            "abstractKey": "__isLogable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f36bccbe4fa09b4e57b8c4ce4a0b476e",
    "id": null,
    "metadata": {},
    "name": "HotelEditMainMutation",
    "operationKind": "mutation",
    "text": "mutation HotelEditMainMutation(\n  $id: ID!\n  $input: UpdateHotelInput!\n  $first: Int!\n  $after: String\n  $search: String\n  $sort: RoomSorting\n) {\n  updateHotel(id: $id, input: $input) {\n    ...HotelEditTabs_hotel\n    ...HotelSidebar_hotel\n    id\n  }\n}\n\nfragment AddRoomDialog_hotel on Hotel {\n  id\n}\n\nfragment EditorJsField_text on Text {\n  id\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n  ...EditorToolbar_text\n}\n\nfragment EditorLanguageButton_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n}\n\nfragment EditorToolbar_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        ...EditorTranslateButton_textBlock\n        id\n      }\n    }\n  }\n  ...EditorLanguageButton_text\n}\n\nfragment EditorTranslateButton_textBlock on TextBlock {\n  id\n  data\n}\n\nfragment EntityHistoryEntryIcon_entry on LogEntry {\n  severity\n}\n\nfragment EntityHistoryEntry_entry on LogEntry {\n  name\n  createdAt\n  description\n  user {\n    name\n    id\n  }\n  ...EntityHistoryJsonContext_entry\n  ...EntityHistoryEntryIcon_entry\n}\n\nfragment EntityHistoryJsonContext_entry on LogEntry {\n  context\n}\n\nfragment EntityHistory_entity on Logable {\n  __isLogable: __typename\n  logs {\n    id\n    ...EntityHistoryEntry_entry\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment HotelEditMainGeneral_hotel on Hotel {\n  source\n  externalId\n}\n\nfragment HotelEditMain_hotel on Hotel {\n  id\n  name\n  stars\n  features\n  reviews\n  description\n  aboutLocation\n  source\n  userEdited\n  city {\n    id\n    name\n  }\n  location {\n    lat\n    lng\n    id\n  }\n  descriptionText {\n    ...useEditorJsField_text\n    ...EditorJsField_text\n    id\n  }\n  aboutLocationText {\n    ...useEditorJsField_text\n    ...EditorJsField_text\n    id\n  }\n  ...HotelEditMainGeneral_hotel\n}\n\nfragment HotelEditRoomsRow_room on Room {\n  id\n  nameString\n  capacity\n}\n\nfragment HotelEditRooms_hotel on Hotel {\n  id\n  rooms(first: $first, after: $after, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        ...HotelEditRoomsRow_room\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...AddRoomDialog_hotel\n}\n\nfragment HotelEditTabs_hotel on Hotel {\n  media(first: 2147483647) {\n    pageInfo {\n      total\n    }\n  }\n  rooms(first: $first, after: $after, search: $search, sort: $sort) {\n    pageInfo {\n      total\n    }\n  }\n  ...HotelEditMain_hotel\n  ...MediaEditor_mediable\n  ...EntityHistory_entity\n  ...HotelEditRooms_hotel\n}\n\nfragment HotelSidebar_hotel on Hotel {\n  source\n  ...EntitySidebar_entity\n}\n\nfragment MediaEditorPreviews_media on MediaConnection {\n  edges {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorSort_media on MediaConnection {\n  edges {\n    node {\n      id\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaEditor_mediable on Mediable {\n  __isMediable: __typename\n  id\n  media(first: 2147483647) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MediaEditorPreviews_media\n    ...MediaEditorSort_media\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n\nfragment useEditorJsField_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "78ccea57699353cd3395d1f1c04ad7d2";

export default node;
